import { useSelector } from 'react-redux';
import { useGetCurrentUserQuery } from '../redux/apis';

/**
 * Centralized hook for accessing the current user.
 * Uses proper skip/cache settings to prevent redundant /users/me polling.
 * All components needing user data should use this hook instead of
 * calling useGetCurrentUserQuery() directly.
 */
export const useUser = () => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const { data: user, isLoading, error, refetch } = useGetCurrentUserQuery(undefined, {
    skip: !isAuthenticated,
    refetchOnMountOrArgChange: false,
  });
  return { user, isLoading, error, refetch };
}; 